import React from 'react'

import { SwitchButton } from './DiscoveryRunForm.styled'

// Minimal accessible switch — no toggle component exists in @tribegroup yet
// (see DiscoveryRunForm.styled.ts's SwitchButton). A small standalone
// component (rather than inlining SwitchButton everywhere) keeps the
// role/aria wiring in one place for future reuse.
interface IProps {
  on: boolean
  disabled?: boolean
  onToggle: () => void
  label?: string
  'data-testid'?: string
}

const Switch: React.FC<IProps> = ({ on, disabled, onToggle, label, ...rest }) => (
  <SwitchButton
    type="button"
    role="switch"
    aria-checked={on}
    aria-label={label}
    $on={on}
    disabled={disabled}
    onClick={onToggle}
    {...rest}
  />
)

export { Switch }
export default Switch
